import { enableViews } from '@gonfalon/dogfood-flags/dogfood-flags';

import { flagProjectFilters } from './flagProjectFilters';
import { isDefaultFlagFilterValue } from './internal/isDefaultFlagFilterValue';
import { type UIFlagFilter } from './types';

export function countActiveProjectFilters(filters: UIFlagFilter | undefined) {
  if (filters === undefined) {
    return 0;
  }

  let count = 0;

  for (const key of flagProjectFilters) {
    const value = filters[key];

    if (value === undefined) {
      continue;
    }

    // This is a project-level filter on the Guarded Rollouts page, but an
    // environment-level filter on the flags page. This check keeps us
    // from incrementing the project filter count on the flags page when
    // an env filter has been selected.
    if (key === 'guardedRollout') {
      continue;
    }

    // Exclude view from the count if it's enabled since it has its own filter
    if (key === 'view' && enableViews()) {
      continue;
    }

    if (isDefaultFlagFilterValue(key, value)) {
      continue;
    }

    if (typeof value === 'string') {
      if (value !== '') {
        count++;
        continue;
      }
    }

    if (Array.isArray(value)) {
      if (value.length > 0) {
        count++;
        continue;
      }
    }

    count++;
  }

  return count;
}
